import alphanumeric from "./alphanumeric";

export const message = (errorType, field, args = {}) => {
  const message = {
    Email: `Please use valid email address! Usually using “@mail.com”.`,
    Empty: `${field} must empty`,
    NotEmpty: `You can’t leave this ${field} empty`,
    Numeric: `${field} must be numeric value`,
    Phone: `${field} must be numeric/phone value`,
    MaxLength: `${field} max ${args.len} characters`,
    MinLength: `${field} min ${args.len} characters`,
    Checked: `${field} must be checked`,
    Selected: `${field} must be selected`,
    Url: `Please use valid URL! `,
    Alphanumeric: `${field} must be alphanumeric value`,
    NewMaxLength: `${field} can't max than ${args.len} characters`,
    NewMinLength: `${field} must be at least ${args.len} characters`,
    NewNotEmpty: `This field is required! Please enter ${field}`,
    MaxValue: `For ${field} maximum value can't be higher than ${args.len}`,
    MinValue: `For ${field} minimum value can't be lower than ${args.len}`,
  }
  return message[errorType]
}

export const debounce = (fn, delay) => {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}
